export default __webpack_public_path__ + "static/media/build3.83cb5a6a.png";